import { ReactNode } from 'react';
import { Box, BoxProps } from 'theme-ui';

interface ErrorMessageProps extends BoxProps {
  message: ReactNode
}

export default function ErrorMessage({ message, className, ...props }: ErrorMessageProps) {
  return message ? (
    <Box
      className={className}
      sx={{
        color: 'red'
      }}
      {...props}
    >
      {message}
    </Box>
  ): null;
}
